import ConnectedPopperMenu from './ConnectedPopperMenu';

export default ConnectedPopperMenu;
